import React, { useRef } from "react";

export default function FilterItem({ value, index, active, onClickHandler }) {
  const checkbox = useRef(null);
  const componentClickHandler = (e) => {
    checkbox.current.checked = !checkbox.current.checked;
    onClickHandler();
  };
  return (
    <div
      key={index}
      onClick={componentClickHandler}
      className="filter-item-box d-flex align-items-center"
    >
      <input ref={checkbox} type="checkbox" checked={active} />
      <div className="item-name">{value}</div>
    </div>
  );
}
